import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Field } from 'redux-form';
import Input from '../../../../common/input';

const PercentageInputComponent = ({ shop, hidden }) => (
  <div className="c-table-card__cell u-4/10" display-if={!hidden}>
    <Input
      className="c-input"
      name={`shops.${shop.id}.percentage`}
      type="number"
      step="0.001"
      prefix="%"
      normalize={value => (value === '' ? value : parseFloat(value))}
      placeholder="Tax percentage"
    />
  </div>
);

PercentageInputComponent.propTypes = {
  shop: PropTypes.shape({ id: PropTypes.string }).isRequired,
  hidden: PropTypes.bool,
};

PercentageInputComponent.defaultProps = {
  hidden: true,
};

const ShopItem = ({ shop, disabled, selected }) => (
  <div className="c-table-card__row c-table-card__row--transparent">
    <div className="c-table-card__cell u-1/10">
      <div className="c-checkbox u-mr">
        <Field
          type="checkbox"
          name={`shops.${shop.id}.enabled`}
          normalize={value => !!value}
          component={field => (
            <input
              {...field.input}
              className={cx('c-checkbox__input', { 'is-indeterminate': !field.input.value })}
              type="checkbox"
              id={`shops.${shop.id}.enabled`}
              disabled={disabled}
            />
          )}
        />
        <label className="c-checkbox__label" htmlFor={`shops.${shop.id}.enabled`}>
          <span className="c-checkbox__trigger" />
        </label>
      </div>
    </div>
    <div className="c-table-card__cell u-5/10">{shop.name}</div>
    <PercentageInputComponent shop={shop} hidden={!selected} />
  </div>
);

ShopItem.propTypes = {
  shop: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }).isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
};

ShopItem.defaultProps = {
  disabled: false,
  selected: false,
};

export default ShopItem;
